var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"8"}},[_c('h2',{staticClass:" primary--text"},[_vm._v(" "+_vm._s(this.$t(_vm.titulo))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }